import React from "react";

interface MediaCardProps {
  imageUrl?: string | null;
  imageAlt: string;
  /** Shown in place of a missing image; without it, a card without image has no media block. */
  placeholderIcon?: React.ReactNode;
  badge?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

const MediaCard: React.FC<MediaCardProps> = ({
  imageUrl,
  imageAlt,
  placeholderIcon,
  badge,
  actions,
  children,
}) => (
  <div className="flex flex-col overflow-hidden rounded-lg border border-gray-200 bg-white transition-colors hover:border-gray-300">
    {(imageUrl || placeholderIcon) && (
      <div className="relative border-b border-gray-200">
        {imageUrl ? (
          <div className="aspect-video w-full overflow-hidden bg-gray-50">
            <img
              src={imageUrl}
              alt={imageAlt}
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>
        ) : (
          <div className="flex aspect-video w-full items-center justify-center bg-gray-50">
            {placeholderIcon}
          </div>
        )}
        {badge && <div className="absolute right-3 top-3">{badge}</div>}
      </div>
    )}

    <div className="flex flex-1 flex-col gap-3 p-4">
      {!(imageUrl || placeholderIcon) && badge && (
        <div className="self-end">{badge}</div>
      )}
      {children}
      {actions && (
        <div className="mt-auto flex flex-wrap items-center gap-2 pt-1">
          {actions}
        </div>
      )}
    </div>
  </div>
);

export default MediaCard;
